import { format } from "date-fns";
import { sanitizeHtml } from "@repo/ui/lib/sanitizeHtml";
import { articleListStyles as s } from "./ArticleList.styles";
import type { ArticleItemData, ArticleListData } from "./ArticleList.types";

function isArticleItem(value: unknown): value is ArticleItemData {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const article = value as Record<string, unknown>;
  return typeof article.title === "string" && typeof article.preview === "string";
}

export function ArticleList({ articles }: ArticleListData) {
  const validArticles = (Array.isArray(articles) ? articles : []).filter(isArticleItem);

  if (validArticles.length === 0) {
    return null;
  }

  return (
    <div className={s.list}>
      {validArticles.map((article, index) => (
        <ArticleCard key={`${article.title}-${index}`} article={article} />
      ))}
    </div>
  );
}

function ArticleCard({ article }: { article: ArticleItemData }) {
  const { title, preview, date_created, date_updated, link } = article;
  const hasHttpsLink = typeof link === "string" && link.startsWith("https://");
  const timestamp = date_updated ?? date_created;

  return (
    <div className={s.item}>
      {hasHttpsLink ? (
        <a href={link} target="_blank" rel="noopener noreferrer" className={s.titleLink}>
          {title}
        </a>
      ) : (
        <p className={s.title}>{title}</p>
      )}
      {timestamp && <p className={s.timestamp}>{formatTimestamp(timestamp)}</p>}
      <div className={s.body} dangerouslySetInnerHTML={{ __html: sanitizeHtml(preview) }} />
    </div>
  );
}

function formatTimestamp(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return format(date, "MMM d, yyyy");
}
